<template>
  <div class="enter-page">
    <div class="intro-blk py-5">
      <div class="text-center container">
        <h1 class="text-center mb-1 text-campaign-green" v-html="$t('Home.IntroTitle')"></h1>
        <h2 class="text-center mb-3 text-body-color  text-uppercase" v-html="$t('Home.IntroSub')"></h2>
        <p class="home-paragraph mb-0 mx-auto" v-html="$t('Home.IntroDesc')"></p>
      </div>
    </div>

    <div class="container">
      <div class="row align-items-start">
        <!-- Desktop: Left, Mobile: 2nd & 3rd -->
        <div class="col-md-6 order-2 order-md-1 mt-4 mt-md-0">
          <img
            src="https://snippcheck.blob.core.windows.net/files/Suntory_2008309_HornitosDiadelosMuertos2025/reg-lt-tp.png"
            onerror="this.src='https://snippcheck.blob.core.windows.net/files/Suntory_2008309_HornitosDiadelosMuertos2025/reg-lt-tp.jpg'"
            alt="Mexico City" class="img-fluid w-100 mb-4" style="border-radius: 4px;" />

          <img
            src="https://snippcheck.blob.core.windows.net/files/Suntory_2008309_HornitosDiadelosMuertos2025/reg-lt-btm.png"
            onerror="this.src='https://snippcheck.blob.core.windows.net/files/Suntory_2008309_HornitosDiadelosMuertos2025/reg-lt-btm.jpg'"
            alt="Dia de los Muertos" class="img-fluid w-100 mb-4 mb-md-0" style="border-radius: 4px;" />
        </div>

        <!-- Desktop: Right, Mobile: 1st -->
        <div class="col-md-6 order-1 order-md-2">
          <section class="wrapper mt-0">
            <component :is="WidgetComponent" :campaign-id="$t('CampaignID')" :key="$i18n.locale"></component>
          </section>
        </div>
      </div>
    </div>

    <div class="mt-5 pt-5">
      <img
        src="https://snippcheck.blob.core.windows.net/files/Suntory_2008309_HornitosDiadelosMuertos2025/reg-btm-banner.jpg"
        class="img-fluid" alt="bottom banner">
    </div>
  </div>
</template>
<script>
import CampaignWidgets from '../Home/Homepagecomponents/CampaignWidgets.vue';

export default {
  components: { CampaignWidgets },
  props: {

  },
  data() {
    return {
      showComponent: false,
      WidgetComponent: CampaignWidgets,
    };
  },
};
</script>
